import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <Section className="bg-primary text-dark text-center border-t-4 border-gold" data-id="element-225">
      <div className="max-w-3xl mx-auto" data-id="element-226">
        <div className="animate-float" data-id="element-227">
          <ShieldCheck className="w-16 h-16 md:w-24 md:h-24 mx-auto mb-4 md:mb-6 text-gold drop-shadow-lg" data-id="element-228" />
        </div>
        <h2 className="text-2xl md:text-5xl font-black mb-4 md:mb-8 text-dark" data-id="element-229">
          🛡️ GARANTÍA — 7 DÍAS
        </h2>

        <div className="bg-white/20 p-4 md:p-8 rounded-xl md:rounded-2xl backdrop-blur-sm border border-white/30 mb-4 md:mb-8 shadow-xl" data-id="element-230">
          <p className="text-base md:text-2xl font-bold mb-2 md:mb-4 text-dark" data-id="element-231">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu entrenamiento
            si querés.
          </p>
          <p className="text-xl md:text-3xl font-black text-gold mb-3 md:mb-6" data-id="element-232">
            Si en 7 días no es lo que esperabas:
            <br data-id="element-233" />
            Te devolvemos el 100%.
          </p>
          <p className="text-sm md:text-lg font-medium text-dark/80" data-id="element-234">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-sm md:text-lg text-dark/90 font-medium leading-relaxed" data-id="element-235">
          Más de 300 instructores de fútbol de todo el país ya lo saben.
          <br data-id="element-236" />
          <span className="font-bold text-gold" data-id="element-237">
            La tasa de devoluciones es menor al 1%.
          </span>
        </p>
      </div>
    </Section>;
}